import glamorous from 'glamorous'

export const GiftCardsContent = glamorous.div({
  maxWidth: '736px',
  margin: 'auto',
})

export const ImageContent = glamorous.div({
  display: 'inline-block',
  maxWidth: '912px',
})

export const ProductDiv = glamorous.div({
  margin: '36px auto',
  maxWidth: '800px',
  backgroundColor: '#ffffff',
})
